<script>
    export default {
        name: "SubscriptionOverviewSection",
        data () {
            return {
                sectionType: "subscription-overview-section"
            }
        },
        computed : {
            dummyData () {
                return {
                    currency: "$",
                    price: "5",
                    translatedIntervalText: this.$t('common.months'),
                }
            },
            mySubscriptionData () {
                let subscriptionFound = {};

                this.subscriptions.map(subscription => {
                    if (subscription.titleId === this.selectedSubscriptionId) {
                        subscriptionFound = subscription;
                    }
                })

                return subscriptionFound;
            },
            selectedSubscriptionId () {
                if (this.sectionData.selectedSubscriptionId) {
                    return this.sectionData.selectedSubscriptionId;
                }

                if (this.isPageContext('subscription') && this.pageContext.params && this.subscriptions.filter( subscription => subscription.titleId === this.pageContext.params.slug).length ) {
                    return this.pageContext.params.slug;
                }

                return "";
            },
            subscriptionSelectOptions () {
                let options =   this.subscriptions.map( subscription => {
                    return {label: subscription.title, value: subscription.titleId};
                });

                if (!this.isPageContext('subscription')) {
                    options.unshift({label: "None", value: ""});
                }
                return options;
            },
        },
        methods: {
            getSelectedSubscription () {
                return this.selectedSubscriptionId;
            },
            getDataForContext () {
                // const subscriptionData = this.subscriptions[this.subscriptions.length - 1]; // latest subscription
                return new Promise( (resolve,reject) => {

                    if (!this.mySubscriptionData.titleId) {
                        resolve(this.dummyData);
                    }

                    resolve(this.editSubscriptionData(this.mySubscriptionData));
                });
            },
            editSubscriptionData (subscriptionData) {
                /**
                 * @param {Object} subscriptionData Subscription data
                 * @param {string} subscriptionData.title The subscription title
                 * @param {string} subscriptionData.description The subscription description
                 * @param {number} subscriptionData.price The subscription price
                 * @param {string} subscriptionData.currency Currency symbol
                 * @param {string} subscriptionData.interval_type Subscription interval type eg "month" Needs translate
                 * @param {number} subscriptionData.interval Number of payments in given interval_type
                 * @param {array} subscriptionData.courses Courses included in the subscription
                 */

                if (!subscriptionData) {
                    return subscriptionData;
                }

                if (typeof subscriptionData.interval_type !== 'undefined' && typeof subscriptionData.interval !== 'undefined') {
                    let translatedIntervalText = this.$t('common.' + subscriptionData.interval_type);

                    if (subscriptionData.interval > 1) {
                        translatedIntervalText = subscriptionData.interval + " " + this.$t('common.' + subscriptionData.interval_type + 's');
                    }
                    subscriptionData.translatedIntervalText = translatedIntervalText;
                }

                return subscriptionData;
            },
            setSelectedSubscription (subId) {
                this.changeMyData({selectedSubscriptionId:subId});
                this.setChangesAreSaved(false);
            },
        }
    }
</script>
